export interface Payment {
  orderNumber: string;
  invoceNumber: string;
  sellerName: string;
  clientName: string;
  methodOfPayment: string;
  paymentDate: string;
  baseValue: number;
  value: number;
  balance: string;
  state: string;
  url: string;
  cancelUrl: string;
  vouchers: string[];
  cancellationComments: string;
  key: string;
}

export interface PaymentWrapper {
  value: Payment;
}

export interface CancelPaymentRequest {
  key: string;
  cancellationComments: string;
}

export function PaymentActions() {
  function infoPayment(
    orderNumber: string,
    invoceNumber: string,
    sellerName: string,
    clientName: string,
    methodOfPayment: string,
    paymentDate: string,
    baseValue: number,
    value: number,
    balance: string,
    state: string,
    url: string,
    cancelUrl: string,
    vouchers: string[],
    cancellationComments: string,
    key: string
  ): Payment {
    return {
      orderNumber: orderNumber,
      invoceNumber: invoceNumber,
      sellerName: sellerName,
      clientName: clientName,
      methodOfPayment: methodOfPayment,
      paymentDate: paymentDate,
      baseValue: baseValue,
      value: value,
      balance: balance,
      state: state,
      url: url,
      cancelUrl: cancelUrl,
      vouchers: vouchers,
      cancellationComments: cancellationComments,
      key: key,
    };
  }

  function paymentCancelRequest(
    key: string,
    cancellationComments: string
  ): CancelPaymentRequest {
    return {
      key: key,
      cancellationComments: cancellationComments,
    };
  }

  function deserialize(object: string): Payment[] {
    const parseResponse: PaymentWrapper[] = JSON.parse(JSON.stringify(object));
    const values: Payment[] = parseResponse.map((wrapper) => wrapper.value);
    return values.map((payment: Payment) => {
      return infoPayment(
        payment.orderNumber,
        payment.invoceNumber,
        payment.sellerName,
        payment.clientName,
        payment.methodOfPayment,
        payment.paymentDate,
        payment.baseValue,
        payment.value,
        payment.balance,
        payment.state,
        payment.url,
        payment.cancelUrl,
        payment.vouchers,
        payment.cancellationComments,
        payment.key
      );
    });
  }

  return {
    infoPayment,
    paymentCancelRequest,
    deserialize,
  };
}
